// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rzDe","colBig":"styles_colBig___WTjA","colSmall":"styles_colSmall__TYx-a"};